import React from "react";
import ReactDOM from "react-dom";
import App from "./app"; // Ton composant principal

// Ce fichier est l'entrée de l'application React
ReactDOM.render(
  <React.StrictMode>
    <App /> {/* Ici, ton composant App est rendu dans le DOM */}
  </React.StrictMode>,
  document.getElementById("root") // "root" fait référence à l'élément dans index.html
);
